import axios from "axios";

const BASE_URL = window.process?.env.DATA_BASE_URL;

// The base url
if (BASE_URL) {
  axios.defaults.baseURL = BASE_URL;
}

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

export default axios;
